import React from "react";

const GreSection = () => {
  return (
    <>
      <section id="gre">
      <div className="container mx-auto px-4">
        <div className="flex flex-col mt-4 items-center">
          <h1 className="mb-3 text-4xl font-extrabold tracking-tight leading-none text-gray-900 md:text-5xl lg:text-6xl mt-10">
          <span className="text-black  bg-gradient-to-r from-red-600 to-blue-600 bg-clip-text text-transparent">
                  GRE
                  </span>
          </h1>
          <div className="flex md:w-[80%] mt-2 mb-2">
            <div className="w-full flex flex-col justify-center mt-3 md:mt-0">
              <p className="mt-2 mb-3 text-lg font-normal text-gray-500 text-justify">
              GRE (Graduate Record Examinations): The GRE is a comprehensive assessment required for admission to many graduate schools worldwide, evaluating verbal reasoning, quantitative ability, and analytical writing skills. Its importance lies in its role as a gateway to advanced study programs, helping institutions assess applicants’ potential for rigorous academic work.
              </p>
              
              </div>
              </div>
              <div>
            <a
              type="button"
              href="https://www.ets.org/gre.html"
              target="_blank"
              class="text-white bg-gradient-to-r from-red-600 to-blue-600 hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-lg px-5 py-2.5 me-2 mb-2"
            >
              Official Website
            </a>
          </div>
              </div>
              </div>
        {/* <div className="py-4 px-4 mx-auto max-w-screen-xl text-center lg:py-16">
          <h2
            data-aos="fade-right"
            className="mb-3 text-4xl font-extrabold tracking-tight leading-none text-gray-900 md:text-5xl lg:text-6xl"
          >
                  <span className="text-black  bg-gradient-to-r from-red-600 to-blue-600 bg-clip-text text-transparent">
                  GRE
                  </span>
          </h2>
          <p className="mb-3 text-lg font-normal text-gray-500 lg:text-xl sm:px-16 lg:px-48">
          GRE (Graduate Record Examinations): The GRE is a comprehensive assessment required for admission to many graduate schools worldwide, evaluating verbal reasoning, quantitative ability, and analytical writing skills. Its importance lies in its role as a gateway to advanced study programs, helping institutions assess applicants’ potential for rigorous academic work.
          </p>
          <div>
            <a
              type="button"
              href="https://www.ets.org/gre.html"
              target="_blank"
              class="text-white bg-gradient-to-r from-red-600 to-blue-600 hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-lg px-5 py-2.5 me-2 mb-2"
            >
              Official Website
            </a>
          </div>
        </div> */}
        <div className="py-4 px-4 mx-auto max-w-screen-xl text-center lg:py-16">
          <h2
            data-aos="fade-right"
            className="mb-3 text-3xl font-extrabold tracking-tight leading-none text-gray-900 md:text-4xl lg:text-5xl"
          >
            GRE Exam Pattern
          </h2>
          {/* <p className="mb-3 text-base font-normal text-gray-500 lg:text-lg sm:px-16 lg:px-48">
            Unlock your potential: Explore the GRE, the gateway to countless
            academic opportunities.
          </p> */}

          
<div className="flex justify-center">
<div class="relative overflow-x-auto shadow-md sm:rounded-lg mt-20">
    <table class="w-full text-sm text-left rtl:text-right text-gray-500">
        <thead class="text-xs text-gray-700 uppercase bg-gray-50">
            <tr>
                <th scope="col" class="px-6 py-3">
                    Section
                </th>
                <th scope="col" class="px-6 py-3">
                    Duration
                </th>
                <th scope="col" class="px-6 py-3">
                    Description
                </th>
                
            </tr>
        </thead>
        <tbody>
            <tr class="bg-white border-b">
                <th scope="row" class="px-6 py-4 font-medium text-gray-900 whitespace-nowrap">
                Verbal
                </th>
                <td class="px-6 py-4">
                60 minutes
                </td>
                <td class="px-6 py-4">
                <ul style={{ listStyleType: 'circle' }}>
  <li> Sentence Equivalence: Understand sentence structure and vocabulary.</li>
  <li> Text Completion: Fill in missing words in a sentence.</li>
  <li> Reading Comprehension: Understand and analyse written passages.</li>
</ul>

                </td>
                
            </tr>
            <tr class="bg-white border-b hover:bg-gray-50">
            
                <th scope="row" class="px-6 py-4 font-medium text-gray-900 whitespace-nowrap">
                Quantitative
                </th>
                <td class="px-6 py-4">
                70 minutes
                </td>
                <td class="px-6 py-4">
                <ul style={{ listStyleType: 'circle' }}>
  <li> Arithmetic: Basic operations, percentages, ratios, and proportions.</li>
  <li> Algebra: Equations, inequalities, exponents, and functions.</li>
  <li> Geometry: Lines, angles, triangles, circles, and polygons.</li>
  <li> Data Analysis: Interpretation of data, statistics, and probability.</li>
</ul>

                </td>
                
            </tr>
            <tr class="bg-white border-b hover:bg-gray-50">
                
                <th scope="row" class="px-6 py-4 font-medium text-gray-900 whitespace-nowrap">
                Analytical Writing
                </th>
                <td class="px-6 py-4">
                60 minutes
                </td>
                <td class="px-6 py-4">
                <ul style={{ listStyleType: 'circle' }}>
  <li> Analyse an Issue: Formulate and articulate a complex issue.</li>
  <li> Analyse an Argument: Evaluate and critique a given argument.</li>
</ul>

                </td>
                
            </tr>
           
        </tbody>
    </table>
</div>
</div></div>

<div className="flex justify-center">
          <div className="py-4 px-4 mx-auto max-w-screen-xl text-center lg:py-16">
            <h2
              data-aos="fade-right"
              className="mb-3 text-3xl font-extrabold tracking-tight leading-none text-gray-900 md:text-4xl lg:text-5xl"
            >
              GRE Time Table
            </h2>
            {/* <p className="mb-3 text-base font-normal text-gray-500 lg:text-lg sm:px-16 lg:px-48">
              Unlock your potential: Explore the GRE, the gateway to countless
              academic opportunities.
            </p> */}

            <div class="relative overflow-x-auto shadow-md sm:rounded-lg mt-20">
    <table class="w-full text-sm text-left rtl:text-right text-gray-500">
        <thead class="text-xs text-gray-700 uppercase bg-gray-50">
            <tr>
                <th scope="col" class="px-6 py-3">
                    Week
                </th>
                <th scope="col" class="px-6 py-3">
                    Focus Area
                </th>
                <th scope="col" class="px-6 py-3">
                    Hours/Day
                </th>
                <th scope="col" class="px-6 py-3">
                    Ideal Practice Papers
                </th>
                <th scope="col" class="px-6 py-3">
                    Study Description
                </th>
            </tr>
        </thead>
        <tbody>
            <tr class="odd:bg-white even:bg-gray-200 border-b border-gray-400">
                <th scope="row" class="px-6 py-4 font-medium text-gray-900 whitespace-nowrap">
                    1
                </th>
                <td class="px-6 py-4">
                Familiarisation
                </td>
                <td class="px-6 py-4">
                2-3 hours
                </td>
                <td class="px-6 py-4">
                1
                </td>
                <td class="px-6 py-4">
                <ul style={{ listStyleType: 'circle' }}>
                <li>Get to know the GRE format and question types. Begin daily vocabulary learning (20 words/day).</li>
                </ul>
                </td>
            </tr>
            <tr class="odd:bg-white even:bg-gray-200 border-b border-gray-400">
                <th scope="row" class="px-6 py-4 font-medium text-gray-900 whitespace-nowrap">
                    2
                </th>
                <td class="px-6 py-4">
                Quantitative  
                </td>
                <td class="px-6 py-4">
                2-3 hours 
                </td>
                <td class="px-6 py-4">
                1-2 
                </td>
                <td class="px-6 py-4">
                <ul style={{ listStyleType: 'circle' }}>
  <li>  Review basic math concepts. Continue vocabulary learning and include daily reading practice.    </li>
</ul>
                </td>
            </tr>
            <tr class="odd:bg-white even:bg-gray-200 border-b border-gray-400">
                <th scope="row" class="px-6 py-4 font-medium text-gray-900 whitespace-nowrap">
                    3
                </th>
                <td class="px-6 py-4">
                    Verbal
                </td>
                <td class="px-6 py-4">
                2-3 hours
                </td>
                <td class="px-6 py-4">
                1-2  
                </td>
                <td class="px-6 py-4">
                <ul style={{ listStyleType: 'circle' }}>
  <li>  Focus on text completion and sentence equivalence. Maintain vocabulary and reading routine.    </li>
</ul>
                </td>
            </tr>
            <tr class="odd:bg-white even:bg-gray-200 border-b border-gray-400">
                <th scope="row" class="px-6 py-4 font-medium text-gray-900 whitespace-nowrap">
                4
                </th>
                <td class="px-6 py-4">
                Analytical Writing 
                </td>
                <td class="px-6 py-4">
                    2-3 hours
                </td>
                <td class="px-6 py-4">
                    2-3
                </td>
                <td class="px-6 py-4">
                <ul style={{ listStyleType: 'circle' }}>
  <li>Practice issue and argument essays. Keep up with vocabulary and daily reading. </li>
</ul>
                </td>
            </tr>
            <tr>
                <th scope="row" class="px-6 py-4 font-medium text-gray-900 whitespace-nowrap">
                    5-8
                </th>
                <td class="px-6 py-4">
                Full-Length Tests 
                </td>
                <td class="px-6 py-4">
                2-3 hours 
                </td>
                <td class="px-6 py-4">
                3-6  
                </td>
                <td class="px-6 py-4">
                <ul style={{ listStyleType: 'circle' }}>
  <li>Start taking full-length practice tests.</li>
  <li>Analyze results to identify weak areas.</li>
  <li>Continue vocabulary and reading.</li>
  <li>Focus on reviewing weak areas and timed practice sections. Consistent vocabulary and reading.</li>
  <li>Take mock tests and refine test-taking strategies. Sustain vocabulary learning and daily reading.</li>
  <li>Final review of all sections. Focus on areas needing improvement. Continue vocabulary and reading.</li>
</ul>
                </td>
            </tr>
        </tbody>
    </table>
</div>
</div></div>

          <div className="py-4 px-4 mx-auto max-w-screen-xl text-center lg:py-16">
            <h2
              data-aos="fade-right"
              className="mb-3 text-3xl font-extrabold tracking-tight leading-none text-gray-900 md:text-4xl lg:text-5xl"
            >
              GRE Resources
            </h2>
            {/* <p className="mb-3 text-base font-normal text-gray-500 lg:text-lg sm:px-16 lg:px-48">
              Unlock your potential: Explore the IELTS, the gateway to countless
              academic opportunities.
            </p> */}

            <div className="py-8 px-4 mx-auto max-w-screen-xl sm:py-16 lg:px-6">
              <div className="container p-4 sm:p-4 border rounded-xl">
                {/* <h2 className="mb-4 text-xl font-semibold leading-tight">List : </h2> */}
                <div className="overflow-x-auto mx-auto">
                  <table className="min-w-full text-sm mx-auto text-center">
                    <thead className="">
                      <tr className="">
                        <th className="p-3 text-lg">Source</th>
                        <th className="p-3 text-lg">Description</th>
                        <th className="p-3 text-lg">Link</th>
                      </tr>
                    </thead>
                    <tbody>
                      {
                        <>
                          <tr className="border-b border-opacity-20">
                            <td className="p-3">
                              <p>Official Website</p>
                            </td>
                            <td className="p-3">
                              <p>Free Practice Tests</p>
                            </td>
                            <td className="p-3">
                              <span className="px-3 py-1 text-blue-700 font-semibold rounded-md dark:bg-violet-400">
                                <a href="https://www.ets.org/gre/test-takers/general-test/prepare/powerprep.html" target="_blank">View</a>
                              </span>
                            </td>
                          </tr>
                          <tr className="border-b border-opacity-20">
                            <td className="p-3">
                              <p>Website: Manhattan</p>
                            </td>
                            <td className="p-3">
                              <p>Free Practice Tests</p>
                            </td>
                            <td className="p-3">
                              <span className="px-3 py-1 text-blue-700 font-semibold rounded-md dark:bg-violet-400">
                                <a href="https://www.manhattanprep.com/gre/free-gre-practice-test/" target="_blank">View</a>
                              </span>
                            </td>
                          </tr>
                          <tr className="border-b border-opacity-20">
                            <td className="p-3">
                              <p>Website/App: Magoosh</p>
                            </td>
                            <td className="p-3">
                              <p>Free Practice Materials and Tests</p>
                            </td>
                            <td className="p-3">
                              <span className="px-3 py-1 text-blue-700 font-semibold rounded-md dark:bg-violet-400">
                                <a href="https://magoosh.com/gre/free-gre-study-materials/" target="_blank">View</a>
                              </span>
                            </td>
                          </tr>
                        </>
                      }
                    </tbody>
                  </table>
                  <small className=" text-[0.7rem]">* Sources</small>
                </div>
              </div>
            </div>
          </div>
      </section>
    </>
  );
};

export default GreSection;

